/* global bocAmchart4 */

/**
 * Get the list of guides and labels from the shortcode and add all the guides to the chart
 *
 * @param {AMConfig} chart Object The chart
 * @return {void}
 */
bocAmchart4.setGuidesFromShortcode = function (chart) {
    var idx = 0;
    var hasMoreData = true;
    var fromShortcode = chart.bocSettings.args;

    while (hasMoreData) {
        if (fromShortcode.hasOwnProperty('guide' + idx + 'start')) {
            var thisAxis = false;
            var axisID = "bottom";
            var isForVerticalAxis = true;
            if (fromShortcode.hasOwnProperty('guide' + idx + 'axis')) {
                axisID = fromShortcode['guide' + idx + 'axis'];
            }
            if (axisID === "bottom" && typeof chart.xAxes === 'object') {
                chart.xAxes.values.forEach(function (axis) {
                    if (axis.id === axisID) {
                        thisAxis = axis;
                        isForVerticalAxis = false;
                    }
                });
            } else {
                if ((axisID === "left" || axisID === "right") && typeof chart.yAxes === 'object') {
                    chart.yAxes.values.forEach(function (axis) {
                        if (axis.id === axisID) {
                            thisAxis = axis;
                        }
                    });
                }
            }

            var guideObj = thisAxis.axisRanges.create();

            var isBand = false;
            if (fromShortcode.hasOwnProperty('guide' + idx + 'end')) {
                isBand = true;
                const endKey = "end" + thisAxis.axisFieldName[0].toUpperCase() + thisAxis.axisFieldName.substring(1);
                const end = fromShortcode['guide' + idx + 'end'];

                if (thisAxis.axisFieldName === "date") {
                    guideObj[endKey] = new Date(end);
                } else if (fromShortcode.hasOwnProperty('xaxistype') && fromShortcode.xaxistype === 'time') {
                    // Try to convert the guide end from time string to seconds
                    if (end.includes(':')) {
                        guideObj[thisAxis.axisFieldName] = bocAmchart4.convertTimeStringToSeconds(end);
                    }
                } else {
                    guideObj[endKey] = end;
                }
            }

            guideObj.label.inside = true;
            var shiftX = 0;
            var shiftY = 0;
            if (isForVerticalAxis) {
                guideObj.label.verticalCenter = isBand ? "middle" : "bottom";
                guideObj.label.align = "left";
                shiftY = isBand ? 0 : 8;
            } else {
                guideObj.label.horizontalCenter = isBand ? "middle" : "left";
                guideObj.label.valign = "bottom";
                guideObj.label.location = 0.5;
                guideObj.label.textAlign = "middle";
                shiftY = 8;
                shiftX = isBand ? 0 : -8;
            }

            guideObj.label.marginTop = 0;

            if (!isForVerticalAxis && isBand) {
                guideObj.label.valign = "top";
                guideObj.label.rotation = 0;
            }

            if (isForVerticalAxis && isBand) {
                guideObj.label.align = "right";
                guideObj.label.rotation = -90;
                guideObj.label.valign = "bottom";
                guideObj.label.textAlign = "middle";
                guideObj.label.verticalCenter = "bottom";
                guideObj.label.horizontalCenter = "middle";
            }

            if (!isForVerticalAxis && !isBand) {
                guideObj.label.rotation = -90;
                guideObj.label.valign = "bottom";
                guideObj.label.horizontalCenter = "left";
            }

            guideObj.label.args = guideObj.label.args ? guideObj.label.args : [];

            if (fromShortcode.hasOwnProperty('guide' + idx + 'labelalign')) {
                guideObj.label.align = fromShortcode['guide' + idx + 'labelalign'];
            }

            if (fromShortcode.hasOwnProperty('guide' + idx + 'labelrotation')) {
                guideObj.label.args['rotation'] = parseFloat(fromShortcode['guide' + idx + 'labelrotation']);
                guideObj.label.adapter.add("rotation", function (value, target) {
                    return target.args['rotation'];
                });
            }

            if (fromShortcode.hasOwnProperty('guide' + idx + 'labelvalign')) {
                guideObj.label.valign = fromShortcode['guide' + idx + 'labelvalign'];
            }

            if (fromShortcode.hasOwnProperty('guide' + idx + 'labeltextalign')) {
                guideObj.label.args['textAlign'] = fromShortcode['guide' + idx + 'labeltextalign'];
                guideObj.label.adapter.add("textAlign", function (value, target) {
                    return target.args['textAlign'];
                });
            }

            if (fromShortcode.hasOwnProperty('guide' + idx + 'labellocation')) {
                guideObj.label.args['location'] = parseFloat(fromShortcode['guide' + idx + 'labellocation']);
                guideObj.label.adapter.add("location", function (value, target) {
                    return target.args['location'];
                });
            }

            if (fromShortcode.hasOwnProperty('guide' + idx + 'labelverticalcenter')) {
                guideObj.label.args['verticalCenter'] = fromShortcode['guide' + idx + 'labelverticalcenter'];
                guideObj.label.adapter.add("verticalCenter", function (value, target) {
                    return target.args['verticalCenter'];
                });
            }

            if (fromShortcode.hasOwnProperty('guide' + idx + 'labelhorizontalcenter')) {
                guideObj.label.args['horizontalCenter'] = fromShortcode['guide' + idx + 'labelhorizontalcenter'];
                guideObj.label.adapter.add("horizontalCenter", function (value, target) {
                    return target.args['horizontalCenter'];
                });
            }

            guideObj.label.fontSize = "0.857em";

            const start = fromShortcode['guide' + idx + 'start'];

            if (thisAxis.axisFieldName === "date") {
                guideObj[thisAxis.axisFieldName] = new Date(start);
            } else if (fromShortcode.hasOwnProperty('xaxistype') && fromShortcode.xaxistype === 'time') {
                // Try to convert the guide end from time string to seconds
                if (start.includes(':')) {
                    guideObj[thisAxis.axisFieldName] = bocAmchart4.convertTimeStringToSeconds(start);
                }
            } else {
                guideObj[thisAxis.axisFieldName] = start;
            }
            let showAsLine = false;
            if (fromShortcode.hasOwnProperty('guide' + idx + 'showasline')) {
                showAsLine = true;
                guideObj.grid.location = 0;
            }

            if (isBand && !showAsLine) {
                guideObj.axisFill.fill = chart.colors.getIndex(30);
                guideObj.axisFill.fillOpacity = 0.1;
                guideObj.grid.strokeOpacity = 1;
                guideObj.grid.location = 1;
                guideObj.grid.stroke = chart.colors.getIndex(30);
                guideObj.grid.strokeWidth = 0.5;
            } else {
                guideObj.grid.strokeOpacity = 0.75;
                guideObj.grid.stroke = chart.colors.getIndex(30);
                guideObj.grid.strokeWidth = 1;
                guideObj.grid.above = true;
            }

            if (fromShortcode.hasOwnProperty('guide' + idx + 'label')) {
                guideObj.label.belongs = guideObj;
                guideObj.label.text = fromShortcode['guide' + idx + 'label'];
                guideObj.label.dataItem.text = guideObj.label.text;
                guideObj.label.wrap = true;
                guideObj.axisFill.isMeasured = true;

                if (isBand) {
                    let labelWidth = false;
                    if (fromShortcode.hasOwnProperty('guide' + idx + 'labelwidth')) {
                        labelWidth = parseInt(fromShortcode['guide' + idx + 'labelwidth']);
                    }

                    guideObj.label.adapter.add("maxWidth", function (maxWidth, target) {
                        target.dataItem.axisFill.validate();
                        let labelRotation = target.getPropertyValue('rotation');
                        let axisOrientation = target.parent.axis.axisLetter === 'X' ? 'horizontal' : 'vertical';
                        let aligned = labelIsAlignedWithAxis(labelRotation, axisOrientation);
                        let perpendicular = labelIsPerpendicular(labelRotation, axisOrientation);
                        let availableSpace;

                        if (axisOrientation === 'horizontal' && aligned
                            || axisOrientation === 'vertical' && perpendicular) {
                            availableSpace = target.dataItem.axisFill.measuredWidth;
                        } else if (axisOrientation === 'vertical' && aligned
                            || axisOrientation === 'horizontal' && perpendicular) {
                            availableSpace = target.dataItem.axisFill.measuredHeight;
                        } else {
                            // This would happen if label is rotated by strange angle, just pass value in this case
                            availableSpace = maxWidth;
                        }

                        if (labelWidth && availableSpace > labelWidth / 16 * bocAmchart4.remPixels) {
                            return labelWidth / 16 * bocAmchart4.remPixels;
                        } else {
                            return availableSpace;
                        }
                    });
                } else {
                    // This section if not for line guide, so no available space to measure
                    if (fromShortcode.hasOwnProperty('guide' + idx + 'labelwidth')) {
                        const labelWidth = parseInt(fromShortcode['guide' + idx + 'labelwidth']);
                        guideObj.label.adapter.add('maxWidth', function () {
                            return labelWidth / 16 * bocAmchart4.remPixels;
                        });
                    }
                }
            }
            if (fromShortcode.hasOwnProperty('guide' + idx + 'labelshiftx')) {
                shiftX = shiftX + parseInt(fromShortcode['guide' + idx + 'labelshiftx']);
            }
            if (fromShortcode.hasOwnProperty('guide' + idx + 'labelshifty')) {
                shiftY = shiftY + parseInt(fromShortcode['guide' + idx + 'labelshifty']);
            }

            guideObj.label.bocProperties = {
                "shiftX": shiftX,
                "shiftY": shiftY
            };

            guideObj.label.adapter.add("dx", function (dx, target) {
                return dx + target.bocProperties.shiftX;
            });
            guideObj.label.adapter.add("dy", function (dy, target) {
                return dy + target.bocProperties.shiftY;
            });

            if (bocAmchart4.debug(chart)) {
                // eslint-disable-next-line no-console
                console.log(
                    chart.bocSettings.id,
                    "Adding guide from shortcode:",
                    bocAmchart4.debugClone(guideObj),
                    "Shortcode:",
                    fromShortcode
                );
            }
        } else {
            hasMoreData = false;
        }
        idx++;
    }
};

/**
 * Validates a label is aligned with a given axis
 * @param {int} labelRotation Rotation of the label in degrees
 * @param {string} axisOrientation Orientation of the axis, "horizontal" or "vertical"
 * @returns {boolean} True if the label is aligned with the axis
 */
function labelIsAlignedWithAxis(labelRotation, axisOrientation) {
    if (axisOrientation === 'horizontal') {
        return Math.abs(Math.cos(labelRotation / 180 * Math.PI)) === 1;
    }
    return Math.abs(Math.sin(labelRotation / 180 * Math.PI)) === 1;
}

/**
 * Validates a label is perpendicular to an axis
 * @param {int} labelRotation Rotation of the label
 * @param {string} axisOrientation Orientation of the label, horizontal or vertical
 * @returns {boolean} True if the label is perpendicular
 */
function labelIsPerpendicular(labelRotation, axisOrientation) {
    if (axisOrientation === 'horizontal') {
        return Math.abs(Math.sin(labelRotation / 180 * Math.PI)) === 1;
    }
    return Math.abs(Math.cos(labelRotation / 180 * Math.PI)) === 1;
}
